export const PKG_NAME = "@hpcc-js/ddl-shim";
export const PKG_VERSION = "3.5.0";
export const BUILD_VERSION = "3.34.1";
